module.exports = __webpack_public_path__ + "img/food.101aab07.jpeg";